import { render } from "./EditFarmerModal4.vue?vue&type=template&id=7d596092&scoped=true"
import script from "./EditFarmerModal4.vue?vue&type=script&lang=js"
export * from "./EditFarmerModal4.vue?vue&type=script&lang=js"

import "./EditFarmerModal4.vue?vue&type=style&index=0&id=7d596092&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d596092"]])

export default __exports__